{
  "signIn": {
    "description": "Enter your account details.",
    "username": "Username",
    "rejected": "Wrong username or password.",
    "blocked": "This account is blocked. Contact an administrator.",
    "rateLimited": "Too many sign-in attempts. Try again later.",
    "unavailable": "The authentication server is unavailable.",
    "noAccount": "No account?",
    "register": "Register"
  },
  "register": {
    "title": "Registration",
    "description": "The username can only be changed by an administrator later.",
    "username": "Username",
    "usernameHint": "Letters, digits, underscore",
    "password": "Password",
    "submit": "Create account",
    "haveAccount": "Already have an account?",
    "signIn": "Sign in",
    "taken": "That username is already taken.",
    "invalid": "The username or password does not meet the rules.",
    "closed": "Registration is closed.",
    "rateLimited": "Too many attempts. Try again later.",
    "unavailable": "The authentication server is unavailable.",
    "usernamePattern": "Lowercase letters, digits and underscore only, 3 to 32 characters",
    "usernameReserved": "This username is reserved"
  },
  "account": {
    "title": "Account",
    "description": "Password and active sessions.",
    "forcedTitle": "Change your password",
    "forcedDescription": "This password was set by an administrator. The rest stays locked until it is changed.",
    "password": {
      "title": "Password",
      "description": "Changing the password ends every session but this one.",
      "current": "Current password",
      "next": "New password",
      "repeat": "Repeat new password",
      "submit": "Change password",
      "mismatch": "The passwords do not match",
      "wrongCurrent": "Wrong current password"
    },
    "sessions": {
      "title": "Active sessions",
      "description": "Every sign-in creates its own session.",
      "empty": "No active sessions",
      "current": "Current",
      "columns": {
        "ip": "IP",
        "userAgent": "Device",
        "created": "Started",
        "expires": "Expires"
      },
      "revokeAll": "Sign out everywhere",
      "revokeTitle": "Sign out everywhere?",
      "revokeDescription": "Every session ends, this one included. You will have to sign in again.",
      "revokeSubmit": "Sign out everywhere"
    }
  },
  "sudo": {
    "title": "Confirm your password",
    "description": "This action touches accounts, so a password is required.",
    "password": "Password",
    "submit": "Confirm",
    "failed": "Wrong password."
  }
}
